(function () {
  'use strict';

  angular.module('ringbaPortal').component('trTarget', {
    bindings: {
      onSave: '&',
      onDismiss: '&',
      target: '<',
      targetIdToClone: '@'
    },
    controller: TargetController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/targets/target.view.html'
  });

  function TargetController(
    $state,
    $stateParams,
    $anchorScroll,
    accountsService,
    concurrencyMatrixService,
    infoService,
    targetService,
    utils
  ) {

    const vm = this;

    vm.targetId = ($stateParams.targetId) ? $stateParams.targetId : null;
    vm.targetIdToClone = $stateParams.sourceTargetId || null;

    vm.$onInit = onInit;
    vm.onSaveTarget = onSaveTarget;

    function onInit() {
      if (vm.target) {
        _loadTarget(vm.target);
      }
      else if (vm.targetIdToClone) {
        _loadAndCloneTarget(vm.targetIdToClone);
        vm.targetIdToClone = null;
      }

      _loadConversionSettings();
    }

    function onSaveTarget(event) {
      $anchorScroll();
      if (event.newTarget) {
        _changeURLByAddingId(event.target.id);
        vm.targetId = event.target.id;
      }
      vm.currentTarget = event.target;
      vm.currentTarget.schedule.callConcurrencyMatrix = concurrencyMatrixService.getProcessMatrix(vm.currentTarget.schedule.callConcurrencyMatrix);
      vm.currentTarget.schedule.callCapMatrix = concurrencyMatrixService.getProcessMatrix(vm.currentTarget.schedule.callCapMatrix);

      vm.onSave(event);
    }

    function _changeURLByAddingId(targetId) {
      $state.go('dashboard.target.new', {
        targetId: targetId
      });
    }

    function _loadConversionSettings() {
      infoService.getConversionSettings()
        .then(function (response) {
          vm.conversionSettings = response.data;
        })
        .catch(utils.errorHandler);
    }

    function _loadTarget(target) {
      // Copying for safety since its being changed underneath
      _setCurrentTarget(angular.copy(target));
    }

    function _loadAndCloneTarget(targetId) {
      targetService.duplicateTarget(accountsService.currentAccountId, targetId)
        .then(function (target) {
          _setCurrentTarget(target);
        })
        .catch(utils.errorHandler);
    }

    function _setCurrentTarget(target) {
      vm.currentTarget = target;
      if (vm.currentTarget.schedule && vm.currentTarget.schedule.callConcurrencyMatrix) {
        vm.currentTarget.schedule.callConcurrencyMatrix = concurrencyMatrixService.getProcessMatrix(vm.currentTarget.schedule.callConcurrencyMatrix);
      }

      if (vm.currentTarget.schedule && vm.currentTarget.schedule.callCapMatrix) {
        vm.currentTarget.schedule.callCapMatrix = concurrencyMatrixService.getProcessMatrix(vm.currentTarget.schedule.callCapMatrix);
      }
    }

  }
})();
